import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";
import UpdateAnnouncementApiRequest from "../request/UpdateAnnouncementApiRequest";

const UpdateAnnouncementApiService = async (request: UpdateAnnouncementApiRequest): Promise<void> => {
  const url = `/announcements/${request.id}/`;
  const { data } = await axios.put(url, request);
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useUpdateAnnouncementApiService = () =>
  useMutation<void, AxiosError, UpdateAnnouncementApiRequest>(
    UpdateAnnouncementApiService, {
      mutationKey: "UpdateAnnouncementApiService"
    }
  );
export default useUpdateAnnouncementApiService;